<template>
<hsc-window-style-metal>
    <hsc-window title="Data Integration" :resizable="false" :left="x" :top="y" :width="width" :height="height" :zGroup="group"  :closeButton="true" :isOpen.sync="dialogIsOpen">
      <mdb-tabs class="table-tabs mb-2 form" :active="active" default :links="tabs" @activeTab="getActiveTabIndex">
             <template v-if="tabData.length > 0">
                 <template v-for="(arr,index) in tabData" :slot="arr.slug">
                    <template v-if="index === 0 && toUpdate === 0">
                        <mdb-alert color="info" :key="'alert-info' + index" class="mb-0">
                            No record to update.
                        </mdb-alert>
                    </template>
                    <template v-if="arr.errors.length > 0">
                         <mdb-alert color="danger" :key="'alert' + index" class="mb-0">
                            {{arr.errors[0].message}}
                        </mdb-alert>
                    </template>
                     <el-table :key="index" :ref="'importTable'+index" lazy class="custom-element-table" :data="arr.rows" stripe :height="tableHeight" :row-class-name="errorClassName" :cell-class-name="cellClassName">
                             <template v-for="col in arr.columns">
                                    <el-table-column v-bind:key="col.field" :sortable="col.sortable" :width="col.width" :prop="col.field" :label="col.label" :align="col.align" :fixed="col.fixed">
                                    <!-- <el-table-column v-bind:key="col.field" :width="col.width" :prop="col.field" :label="col.label"> -->
                                        <template slot-scope="scope">
                                            <template v-if="col.isAmount">
                                                {{ scope.row[col.field] | amount }}
                                            </template>
                                            <template v-else>
                                            {{ (scope.row[col.field] === 'null' || scope.row[col.field] === null ? '-' : scope.row[col.field]) }}
                                            </template>
                                        </template>
                                    </el-table-column>
                                </template>
                            <template slot="empty">
                                No Data
                            </template>
                        </el-table>
                 </template>
                   
            </template> 
      </mdb-tabs>
      <mdb-container>
            <div class="d-flex">
                 <template v-if="loading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                  <slot name="custon-button"></slot>
                  <button class="btn btn-sm btn-grey" type="button" @click="closeDialog">Close</button>
                </template>
            </div>
        </mdb-container>

    </hsc-window>
</hsc-window-style-metal>
</template>

<script>
import {
    mdbIcon,
    mdbContainer,
    mdbBtn,
    mdbFormInline,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbClickOutside,
     mdbTabs, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane, mdbAlert 
} from "mdbvue";

import { mapGetters, mapMutations,mapActions } from 'vuex';
export default {
    name : "TabTable",
    data(){
        return {
            toggle : false,
            current_page : 1,
            x : 0,
            y : 0,
            dialogIsOpen : false,
            active : 0
        }
    },

    props : {
        tableHeight : {
            type: String,
            default : 'calc(100vh - 130px)'
        },

         group : {
            type : Number,
            default : 1
        },
        height : {
            type : Number,
                default : 600
        },
        width : {
            type : Number,
                default : 1400
        },
        loading : {
            type : Boolean,
            default : false
        }
    },
    components: {
        mdbIcon,
        mdbBtn,
        mdbContainer,
        mdbFormInline,
        mdbDropdown,
        mdbDropdownItem,
        mdbDropdownMenu,
        mdbDropdownToggle,
         mdbTabs, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane,
         mdbAlert
    },
directives: {
      mdbClickOutside
    },

    methods: {
        openDialog(){
            this.dialogIsOpen = true
        },

        closeDialog(){
            this.dialogIsOpen = false
        },

        handleSizeChange(val) {
            
        },
        handleCurrentChange(val) {
            
        },
        handleSearchTerm() {
           
        },
        handleSelectionChange(val){
            
        },
        ClearSelected(){
           
        },

        getValue(scope,string){
            var result = string.split(".");
            const response = [];
            result.forEach(element => {
                response.push(element)
            });

            return scope.row.response;
        },

        importData(){
            this.$emit('import',this.data)
        },
        getActiveTabIndex(index){
            this.active = index
        },

        errorClassName({ row }) {
        if (row.hasOwnProperty('message')) {
            return 'error-row'
        }
        // if(row.update_check_sort === 1){
        //          return 'cell-red'
        //     }else{
        //          return 'cell-success'
        //     }
        },
        cellClassName({row,column}){
            // const redColumn = ['qty','import_price','import_stock','prt_admin_diff','inventory', 'stock','qty_updated','update_check','price','inventory','transactions_count','port_qty','confirmed_order'];
            // // console.log(column)
            // console.log(row)
            
            if(row.update_check_sort === 1){
                 return 'cell-red'
            }else{
                 return 'cell-success'
            }
        }
        

    },

    beforeDestroy() {
        this.x = ((window.innerWidth + 240) - this.width) / 2
        this.y = (window.innerHeight - this.height) / 2
    },
    beforeMount() {

        this.x = ((window.innerWidth + 240) - this.width) / 2
        this.y = (window.innerHeight - this.height) / 2

    },

    computed : {
        ...mapGetters('DataModule',['tabData','toUpdate']),
        tabs : function(){
            let tabsArray = []
                if(this.tabData.length > 0){
                    tabsArray = this.tabData.map((item) => {
                        return {text : item.label, slot : item.slug}
                    })
                }
            return tabsArray
        }
    }

}
</script>
<style scoped>
.table-container{ padding : 0 5px } .custom-element-table{ position: relative; }
</style>

<style>
.dropdown-menu.show{
    top:100%!important;
    position:absolute!important;
}

.select-store .dropdown-menu {
    position: relative!important;
}

.dropdown-menu.sf-dropdown-menu{
    min-width: 600px;background-color: #f3f3f3;
}

.tab-content{
    padding: 0
}
.alert{
    border-radius : 0!important;padding : .25rem 1.25rem!important;
}
</style>